import * as React from "react";
import { forwardRef } from "react";
const LogoGoogleSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "M2.58 12A9.42 9.42 0 0 1 12 2.581c2.408 0 4.605.904 6.27 2.39l-2.597 2.571a5.756 5.756 0 1 0-3.71 10.155c2.498 0 4.436-1.593 5.231-3.82h-.639l-3.923-.009v-3.605h4.836v-.002h3.79q.16.846.161 1.739a9.419 9.419 0 0 1-18.838 0" }));
const ForwardRef = forwardRef(LogoGoogleSVG);
export default ForwardRef;
//# sourceMappingURL=LogoGoogle.js.map